import { createAPI } from '../../common'

export default {
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config
    ),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0efubjm0tubuvt', 'get', config)
}
